import { Textarea } from "@arcadeai/design-system/components/ui/atoms/textarea";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { Control } from "react-hook-form";
import type { UserSourceCreateRequest } from "../../types";

type DescriptionFormFieldProps = {
  control: Control<UserSourceCreateRequest>;
};

export function DescriptionFormField({ control }: DescriptionFormFieldProps) {
  return (
    <FormField
      control={control}
      name="description"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Description (optional)</FormLabel>
          <FormControl>
            <Textarea {...field} value={field.value ?? ""} />
          </FormControl>
          <FormDescription>
            A human-readable description of this identity provider.
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
